/**
 * Processes the application state for a PushTan trade operation and redirects based on the state.
 * This is to be used in trade flows like buy/sell/savings in the accept/page.tsx file,
 * as a child of the AcceptTradeController component.
 *
 * @param {object} props - The properties object.
 * @param {TradeControllerVariants} props.variant - The trade operation variant (buy, sell, savings, etc).
 * @param {TradeBuyApplicationStatePushTan} props.state - The current state of the PushTan trade application.
 * @param {string} props.assetId - The ID of the asset involved in the trade.
 *
 */
import { redirect } from 'next/navigation';
import {
  TradeBuyApplicationStatePushTan,
  TradeControllerVariants,
} from '../../utils/reusableTypes';
import { APPLICATION_STATE_KEY } from './constants';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';

export const processPushTanApplicationState = (props: {
  variant: TradeControllerVariants;
  state: TradeBuyApplicationStatePushTan;
  assetId: string;
}) => {
  const { assetId, state, variant } = props;

  if (state === 'declined' || state === 'failed') {
    redirect(
      `${NEXT_ROUTES.ASSET_DETAILS.replace('[id]', assetId)}/${variant}?${APPLICATION_STATE_KEY}=${state}`,
    );
  }
};
